
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    notifications: {
      type: Object,
    },
    notificationCount: {
      type: Number,
    },
  },
  setup (props) {
    const store = useStore()
    const router = useRouter();

    const logout = () => {
      store.dispatch('Auth/logout')
      window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_TOKEN')
      window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_ID')
      window.location.href = '/login'
    }

    const openNotif = ref(false);
    const isRead = ref("All");
    const notification = ref<any>(props.notifications);
    const allNotification = ref([]) as any;

    const auth_vendor = computed(() => store.getters["AuthVendor/auth_vendor"]);


    function filterNotif(status: any) {
      if (status === isRead.value) {
        allNotification.value = notification.value.data;
        isRead.value = "All";
      } else {
        let read = 0;
        if (status === "read") {
          read = 1;
          isRead.value = "read";
        } else {
          read = 0;
          isRead.value = "unread";
        }
        allNotification.value = notification.value.data.filter(
          (notif: any) => notif.is_read === read
        );
      }
    }

    async function goToNotif(notif: any) {
      await store.dispatch("NotificationVendor/read", { id: notif.id }).then(() => {
       
          window.location.href =
            "/invoice/edit/" + notif.invoice_id;
  
        
      });
    }

    function goToNotifications() {
      openNotif.value = false;
      router.push({
        path: "/notifications",
      });
    }

    function getNotitications() {
      allNotification.value = notification.value.data;
    }

    onMounted(() => {
      getNotitications();
    });
    // const auth_vendor = computed(() => store.getters["AuthVendor/auth_vendor"]);

    return {
      logout,
      openNotif,
      goToNotif,
      goToNotifications,
      filterNotif,
      allNotification,
      isRead,
      auth_vendor,
    }
  },
})
